import { IconCheckLine, Pill, Text } from "@instructure/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExternalService } from "../../../../../../services/ExternalService";

const ExternalStatusIndicator = ({ submissionsGraded, purlId }) => {
  const { t } = useTranslation();
  const [rosterSize, setRosterSize] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRosterSize = async () => {
      try {
        const data = await ExternalService.getPurlDataById(purlId);
        const roster = await ExternalService.getExternalRosterByContext(
          data.section.ddl_id
        );
        setRosterSize(roster.length);
      } catch {
        setRosterSize(0);
      } finally {
        setLoading(false);
      }
    };
    if (purlId) {
      fetchRosterSize();
    } else {
      // No purlId available (pre-feature assessment) — skip fetch, use defaults
      setLoading(false);
    }
  }, [purlId]);

  if (loading) return null;

  const getColor = () => {
    if (rosterSize === 0) return "info";
    if (submissionsGraded === rosterSize) return "success";
    return "warning";
  };

  return rosterSize === 0 ? (
    <Text color="secondary" as="div">
      {t("assessmentPlanningDashboard.authoringAndReview.notStarted")}
    </Text>
  ) : (
    <Pill
      color={getColor()}
      renderIcon={
        submissionsGraded === rosterSize ? <IconCheckLine /> : undefined
      }
    >
      {t("results.externalSubmissionsGraded", {
        submissionsGraded: submissionsGraded,
        rosterSize,
      })}
    </Pill>
  );
};

export default ExternalStatusIndicator;
